
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/detail/[slug]",
      function () {
        return require("private-next-pages/articles/detail/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/detail/[slug]"])
      });
    }
  